/**
 * 앱 열기 · 머문 시간 (명세 v1.3 10장 「첫 경험 D1」 · 「건강: 하루 사용 시간 분포」, D44).
 *
 * - app_open: 처음 열 때, 그리고 30분 넘게 가려져 있다가 다시 보일 때. { path, standalone }
 * - app_active: 화면이 가려지거나 닫힐 때, 그리고 보이는 동안 10분마다 그동안 보고 있던 시간. { ms }
 *   (10분마다 보내는 건 청소년 하루 이용 시간 안내가 화면을 켜 둔 채로도 셀 수 있게, DEV-07z 3 · D99)
 */
import { useEffect, useRef } from 'react';
import { pathKey, track } from '../api/track.js';

const REOPEN_AFTER_MS = 30 * 60 * 1000;
const TICK_MS = 10 * 60 * 1000;

function isStandalone(win) {
    return Boolean(win.matchMedia?.('(display-mode: standalone)').matches);
}

export function useAppActivity() {
    const openedRef = useRef(false);
    useEffect(() => {
        const win = window;
        let visibleSince = document.visibilityState === 'visible' ? Date.now() : null;
        let hiddenAt = null;

        const open = () => track('app_open', { path: pathKey(), standalone: isStandalone(win) });
        const flush = () => {
            if (visibleSince !== null) {
                track('app_active', { ms: Date.now() - visibleSince });
                visibleSince = null;
            }
        };
        const handleVisibility = () => {
            if (document.visibilityState === 'hidden') {
                flush();
                hiddenAt = Date.now();
                return;
            }
            if (hiddenAt !== null && Date.now() - hiddenAt > REOPEN_AFTER_MS) {
                open();
            }
            hiddenAt = null;
            visibleSince = Date.now();
        };

        // 보이는 동안 10분마다 지금까지 본 시간을 보내고 다시 셈
        const tick = win.setInterval(() => {
            if (visibleSince !== null && document.visibilityState === 'visible') {
                flush();
                visibleSince = Date.now();
            }
        }, TICK_MS);

        if (!openedRef.current) {
            openedRef.current = true;
            open();
        }
        document.addEventListener('visibilitychange', handleVisibility);
        win.addEventListener('pagehide', flush);
        return () => {
            win.clearInterval(tick);
            document.removeEventListener('visibilitychange', handleVisibility);
            win.removeEventListener('pagehide', flush);
        };
    }, []);
}
